import { render, staticRenderFns } from "./comprar.vue?vue&type=template&id=18bbd8c6&scoped=true&"
import script from "./comprar.vue?vue&type=script&lang=js&"
export * from "./comprar.vue?vue&type=script&lang=js&"
import style0 from "./comprar.vue?vue&type=style&index=0&id=18bbd8c6&scoped=true&lang=css&"
import style1 from "./comprar.vue?vue&type=style&index=1&id=18bbd8c6&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18bbd8c6",
  null
  
)

export default component.exports